// Toggle dropdown
document.querySelectorAll('.c-sticky-atc .dropdown-select').forEach(el => {
  el.addEventListener('click', e => {
    e.stopPropagation(); // Prevent outside click from firing
    const parent = el.closest('.c-sticky-atc');

    // Close other open dropdowns
    parent.querySelectorAll('.dropdown-select.exp').forEach(openEl => {
      if (openEl !== el) openEl.classList.remove('exp');
    });

    // Toggle current dropdown
    el.classList.toggle('exp');
  });
});

// Close dropdown when clicking outside
document.addEventListener('click', e => {
  document.querySelectorAll('.c-sticky-atc .dropdown-select.exp').forEach(openEl => {
    if (!openEl.contains(e.target)) {
      openEl.classList.remove('exp');
    }
  });
});

// Handle label click inside dropdown
document.querySelectorAll('.c-sticky-atc .dropdown-options label').forEach(label => {
  label.addEventListener('click', e => {
    e.stopPropagation(); // Prevent reopening

    // Get the parent dropdown
    const dropdown = label.closest('.dropdown-select');
    if (!dropdown) return;

    // Get data-selling-plan-name from parent <li>
    const li = label.closest('li');
    const planName = li?.dataset.sellingPlanName || '(no data-selling-plan-name found)';
    

    // Trigger corresponding input click (vanilla JS)
    if (planName === 'one-time') {
      const oneTimeInput = document.querySelector('.product-subscriptions [data-frequency="One-time"]');
      if (oneTimeInput) oneTimeInput.closest('label').click();
    } else {
      const planInput = document.querySelector(`.product-subscriptions [data-selling-plan-name="${planName}"] label`);
      if (planInput) planInput.click();
    }

    // Get new title & price text
    const newTitle = label.querySelector('.product-subscriptions__subscription-label')?.textContent.trim() || '';
    const newPrice = label.querySelector('.product-subscriptions__subscription-price')?.innerHTML || '';

    // Replace displayed values
    const titleEl = dropdown.querySelector('.dropdown-selected__title');
    const priceEl = dropdown.querySelector('.dropdown-selected__price-per-serving');

    if (titleEl) titleEl.textContent = newTitle;
    if (priceEl) priceEl.innerHTML = newPrice;

    // Close the dropdown
    dropdown.classList.remove('exp');
  });
});



// Event delegation for dynamically added buttons
document.body.addEventListener('click', function(e) {
  const target = e.target.closest('.c-sticky-atc .button');
  if (!target) return;

  // Find all buy buttons and trigger click
  document.querySelectorAll('.product-info .buy-buttons .button').forEach(btn => {
    btn.click();
  });
});
